export default __webpack_public_path__ + "static/media/Rectangle-Large.b441745b.svg";